import React, { Fragment, useEffect } from 'react';
import { Row, Spinner } from 'react-bootstrap';
import styled from 'styled-components';
import CommonTable, { CustomTD } from 'components/CommonTable';
import ReportHeader from '../comps/ReportHeader';
import {
	getBuysReport,
	deleteBuyReport,
	getProvinceExcelReport,
} from 'network/apis/ReportingApi';
import { useMutation, useQuery } from 'react-query';
import { PersianDate } from 'helpers/dates';
import { openLink } from 'helpers/general';
import { toast } from 'react-toastify';
import { TbEditCircle } from "react-icons/tb";
import { TiDocumentDelete } from "react-icons/ti";
import useModal from 'hooks/useModal';
import DeleteInputPrompt from "components/DeleteInputPrompt";
import { EmptyLabel } from 'components/CommonWidgets';
import HoverText from 'components/HoverText';
import { useAdminSelector, useAdminDispatch } from 'admin-app/redux/admin.store';
import { buildFiltersQuery, goToPage } from 'admin-app/redux/reporting-filter.slice';

const cols = [
	'حذف',
	// 'ویرایش',
	'توضیحات',
	'تاریخ ثبت',
	'کاربر ثبت کننده',
	'واحد',
	'مقدار',
	'نوع نهاده',
	'ردیف'
];

const Holder = styled.div`
	background-color: white;
	border-bottom-left-radius: 26px;
	border-bottom-right-radius: 26px;
	width: 100%;
	margin: 0;
	padding: 0 2rem;

	div.loading {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #3876e5;
		min-height: 30rem;
	}
	  
	div.header-card {
		display: flex;
		justify-content: end;
		width: 100%;
		margin-bottom: 1.5rem;
	}
`;

const BuysReportTab = ({ currentTab = 'buy-report' }) => {
	const filterState = useAdminSelector((store) => store.reportingFilter);
	const dispatch = useAdminDispatch();

	const {
		isOpen: isEditModalOpen,
		handleOpenModal: handleOpenEditModal,
		handleCloseModal: handleCloseEditModel,
		data: editModalData,
	} = useModal();
	const {
		isOpen: isDeleteModalOpen,
		handleOpenModal: handleOpenDeleteModal,
		handleCloseModal: handleCloseDeleteModel,
		data: deleteModalData,
	} = useModal();

	const { data, refetch, isLoading } = useQuery(
		["get-buys-report-tab", filterState.buysReportFilter],
		() => getBuysReport(filterState.buysReportFilter),
		{
			refetchOnWindowFocus: false,
			enabled: currentTab === 'buy-report'
		}
	);

	const getListItems = () => data?.list?.data?.items ?? [];
	const getStatistics = () => data?.statistics?.data;
	const isEmpty = () => getListItems().length < 1;

	const deleteMutation = useMutation(deleteBuyReport, {
		onSuccess: (res) => {
			if (res && res.status === 204) {
				toast(`با موفقیت حذف گردید`, {
					type: "success",
					position: "bottom-right",
				});

				refetch();
			}
		},
		onError: () => {
			toast(`خطا در حذف، لطفا اتصال خود را بررسی کنید`, {
				type: "error",
				position: "bottom-right",
			});
		},
	});

	const { refetch: fetchTableExcel } = useQuery(
		["get-table-excel", filterState.buysReportFilter],
		() => getBuysReport(filterState.buysReportFilter + 'excel=true'),
		{
			refetchOnWindowFocus: false,
			enabled: false,
			onSuccess: (data) => {
				const url = data?.list?.data?.url;
				if (url) openLink(url);
			},
		}
	);

	const { refetch: fetchProvinceExcel } = useQuery(
		["get-province-excel", filterState.buysReportFilter],
		() => getProvinceExcelReport('purchase', '&' + filterState.buysReportFilter),
		{
			refetchOnWindowFocus: false,
			enabled: false,
			onSuccess: (data) => {
				const url = data?.data;
				if (url) openLink(url);
			},
		}
	);

	const downloadTableExcel = () => {
		fetchTableExcel();
	};

	const downloadProvinceExcel = () => {
		fetchProvinceExcel();
	};

	return (
		<Holder>
			{isLoading ? (
				<div className="loading">
					<Spinner animation="border" role="status" />
				</div>
			) : (
				<Fragment>
					<div className="header-card">
						<ReportHeader
							data={getStatistics()}
							currentTab='buy-report'
							onDownloadTableExcel={downloadTableExcel}
							onDownloadProvinceExcel={downloadProvinceExcel}
						/>
					</div>
					{!isEmpty() ? (
						<CommonTable
							cols={cols}
							pageCount={parseInt(data?.list?.data?.num_pages ?? 1)}
							pageOffset={filterState.pageOffset - 1}
							fetchPageAt={(pageOffset) => {
								dispatch(goToPage(pageOffset));
								dispatch(buildFiltersQuery());
							}}
						>
							{getListItems().map((buy, index) => (
								<tr key={`${buy?.pur_id}-${buy?.created_at}`}>
									<td>
										<TiDocumentDelete
											onClick={() => {
												handleOpenDeleteModal(buy);
											}}
										/>
									</td>
									{/* <td>
										<TbEditCircle onClick={() => {
											handleOpenEditModal(buy);
										}} />
									</td> */}
									<td>
										<HoverText>{buy?.description ?? '-'}</HoverText>
									</td>
									<td>{new PersianDate(buy?.created_at).getParts().join('/')}</td>
									<td>{buy?.created_by?.full_name}</td>
									<td>{buy?.unit?.name}</td>
									<td>{`${buy?.amount ?? 0}`.persianCurrency()}</td>
									<td>{buy?.input?.name}</td>
									<td>{index + 1}</td>
								</tr>
							))}
						</CommonTable>
					) : (
						<EmptyLabel>
							رکوردی ثبت نشده است
						</EmptyLabel>
					)}
					{isDeleteModalOpen && (
						<DeleteInputPrompt
							isOpen={isDeleteModalOpen}
							onClose={handleCloseDeleteModel}
							onActionTap={(warehouseSelected) => {
								handleCloseDeleteModel();
								deleteMutation.mutate({ id: deleteModalData?.pur_id, warehouseSelected: true });
							}}
						/>
					)}
					{/* {isEditModalOpen && (
						<BuyEditModal
							isOpen={isEditModalOpen}
							onClose={handleCloseEditModel}
							data={editModalData}
							onEditSuccess={() => {
								//todo
							}}							
						/>
					)} */}
				</Fragment>
			)}
		</Holder>
	);
};

export default BuysReportTab;
